import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-add-circle",
  "use": "icon-add-circle-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" id=\"icon-add-circle\"><defs><style type=\"text/css\"></style></defs><path d=\"M512 972.8a460.8 460.8 0 1 0 0-921.6 460.8 460.8 0 0 0 0 921.6z m0 51.2C229.2224 1024 0 794.7776 0 512S229.2224 0 512 0s512 229.2224 512 512-229.2224 512-512 512z m-232.704-486.4h465.408a25.6 25.6 0 1 0 0-51.2h-465.408a25.6 25.6 0 0 0 0 51.2zM486.4 279.296v465.408a25.6 25.6 0 1 0 51.2 0v-465.408a25.6 25.6 0 1 0-51.2 0z\" p-id=\"1921\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/svg/add-circle.svg
// module id = uczA
// module chunks = 44